import React from 'react';

export function getSavedSummaryLayout() {
  try { return localStorage.getItem('reportSummaryModern') !== 'false'; } catch (_) { return true; }
}

export default function ReportDisplayControls({ modern, onLayoutChange, filtering, onFilteringChange }) {
  const setLayout = value => {
    try { localStorage.setItem('reportSummaryModern', String(value)); } catch (_) {}
    onLayoutChange(value);
  };
  return <div className="report-display-controls">
    <div className="summary-layout-switch" role="group" aria-label="Summary layout" title="Compare Classic and Modern summary layouts using the same report data">
      <button type="button" aria-pressed={!modern} onClick={() => setLayout(false)}>Classic</button>
      <button type="button" aria-pressed={modern} onClick={() => setLayout(true)}>Modern</button>
    </div>
    <div className="summary-layout-switch" role="group" aria-label="Report filtering" title="When enabled, this report starts from the first trip that leaves the depot and removes earlier trip, virtual trip, parked, and sub-trip records.">
      <button type="button" aria-pressed={!filtering} onClick={() => { if (filtering) onFilteringChange(); }}>Filtering Off</button>
      <button type="button" aria-pressed={filtering} onClick={() => { if (!filtering) onFilteringChange(); }}>Filtering On</button>
    </div>
  </div>;
}
